import { render, staticRenderFns } from "./ScreenPerfilBiofisicoFetal.vue?vue&type=template&id=237ad3af&scoped=true&"
import script from "./ScreenPerfilBiofisicoFetal.vue?vue&type=script&lang=js&"
export * from "./ScreenPerfilBiofisicoFetal.vue?vue&type=script&lang=js&"
import style0 from "./ScreenPerfilBiofisicoFetal.vue?vue&type=style&index=0&id=237ad3af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237ad3af",
  null
  
)

export default component.exports